import { Avatar, Box } from '@mui/material';
import { serverImageUrl } from '../../util';

type Props = {
  displayPictureIds?: string[];
  fallbackName?: string;
  size?: 'small' | 'medium' | 'large';
  maxCount?: number;
};

const sizeConfig = {
  small: {
    container: { width: 40, height: 32 },
    avatar: 24,
    fontSize: '10px',
    offset: 16,
  },
  medium: {
    container: { width: 50, height: 50 },
    avatar: 32,
    fontSize: '12px',
    offset: 18,
  },
  large: {
    container: { width: 60, height: 60 },
    avatar: 40,
    fontSize: '14px',
    offset: 20,
  },
};

export default function StackedAvatars({
  displayPictureIds = [],
  fallbackName = 'U',
  size = 'medium',
  maxCount = 2,
}: Props) {
  const config = sizeConfig[size];
  const displayIds = displayPictureIds.slice(0, maxCount);

  // Single avatar case (including no avatars)
  if (displayIds.length <= 1) {
    const avatarSrc =
      displayIds.length === 1
        ? serverImageUrl({ id: displayIds[0] })
        : undefined;

    return (
      <Avatar
        src={avatarSrc}
        sx={{
          width: config.avatar,
          height: config.avatar,
          backgroundColor: '#E4E7EC',
          color: '#475467',
          fontSize: config.fontSize,
          fontWeight: 500,
        }}
      >
        {fallbackName?.[0] ?? 'U'}
      </Avatar>
    );
  }

  // Multiple avatars case (stacked)
  return (
    <Box sx={{ position: 'relative', ...config.container }}>
      {displayIds.map((id, index) => (
        <Avatar
          key={index}
          src={serverImageUrl({ id })}
          sx={{
            width: config.avatar,
            height: config.avatar,
            backgroundColor: '#E4E7EC',
            color: '#475467',
            fontSize: config.fontSize,
            fontWeight: 500,
            position: 'absolute',
            left: index === 0 ? 0 : `${config.offset}px`,
            top: index === 0 ? 0 : `${Math.floor(config.offset * 0.5)}px`,
            zIndex: displayIds.length - index,
            border: '2px solid white',
          }}
        >
          {`${index + 1}`}
        </Avatar>
      ))}
    </Box>
  );
}
